import React, { useState, useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
  faDownload,
  faPaperPlane,
  faRobot,
  faSearch,
  faFile,
  faPaperclip,
  faSync,
  faExclamationTriangle,
  faComment,
  faFileUpload,
  faLightbulb,
  faClipboardList,
  faCheck,
  faExclamationCircle,
  faUser,
  faClock
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { useParams, useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import moment from "moment";
import { toastr } from "react-redux-toastr";
import sendButtonImg from "../../assets/images/send-chat-button.png";
import { useWebSocket } from '../WebSocket/useWebSocket';
import { addRiskRegister, uploadImageInChat, approveReview, rejectReview } from "../../actions/riskManagement";
import Pagination from "../Pagination/Pagination";
import { API_URL } from "../../utils/constant";
// import "./questionnaireReview.css";

const RiskReview = () => {
  const { _id: assessmentId } = useParams();
  const vendorId = useSelector((state) => state?.summary?.localClient?._id || state?.summary?.clients?.[0]?._id);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [selectedSection, setSelectedSection] = useState("");
  const [sections, setSections] = useState([]);
  const [filteredSections, setFilteredSections] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [questions, setQuestions] = useState([]);
  const [showOnlyFlagged, setShowOnlyFlagged] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState("All Sections");
  const [questionLoading, setQuestionLoading] = useState(false);
  const [showChatBox, setShowChatBox] = useState(false);
  const [showRiskBox, setShowRiskBox] = useState(false);
  const [selectedQuestion, setSelectedQuestion] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [messageInput, setMessageInput] = useState('');
  const [registerFor, setRegisterFor] = useState("forever");
  const [riskLevel, setRiskLevel] = useState("low");
  const [questionId, setQuestionId] = useState("");
  const [categoryId, setCategoryId] = useState("");
  const [riskNote, setRiskNote] = useState("");
  const [riskRecommendation, setRiskRecommendation] = useState("");
  const [riskTitle, setRiskTitle] = useState("");
  const fileInputRef = useRef(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileSent, setFileSent] = useState("");
  const [chatData, setChatData] = useState([]);
  const [assigneeOrganisationId, setAssigneeOrganisationId] = useState("");
  const [assignerOrganisationName, setAssignerOrganisationName] = useState("");
  const [organizationData, setOrganizationData] = useState(null);
  const [isChatMinimized, setIsChatMinimized] = useState(false);
  const [isLoadingOrg, setIsLoadingOrg] = useState(false);
  const [showApproveConfirm, setShowApproveConfirm] = useState(false);
  const [showRejectConfirm, setShowRejectConfirm] = useState(false);
  const [showIncompleteModal, setShowIncompleteModal] = useState(false);
  const [incompleteReason, setIncompleteReason] = useState("");
  const [isMarkingIncomplete, setIsMarkingIncomplete] = useState(false);
  const [aiSummary, setAiSummary] = useState(null);
  const [isLoadingAiSummary, setIsLoadingAiSummary] = useState(false);
  const history = useHistory();

  const vendorInfo = {
    name: "CloudTech Solutions",
    type: "Cloud Infrastructure Provider",
    dataClassification: "Sensitive",
    riskScore: 68,
    submittedDate: "May 2, 2025",
    reviewDeadline: "May 12, 2025"
  };

  const aiAnalysis = {
    overallConfidence: "High",
    potentialIssues: 12,
    missingInfo: 8,
    complianceMatch: 78,
    completedIn: "3 minutes",
    lastUpdated: "1 hour ago",
    recommendation: "Based on the analysis, this vendor requires additional information on data encryption standards and disaster recovery procedures before approval. Consider requesting clarification on these areas."
  };

  const getStatusClass = (status) => {
    return {
      'passed': 'sqr-section-passed',
      'selected': 'sqr-section-selected',
      'review': 'sqr-section-review',
      'incomplete': 'sqr-section-incomplete'
    }[status] || '';
  };

  const getStatusBadge = (status) => {
    return {
      'passed': 'Passed',
      'selected': 'Selected',
      'review': 'Review',
      'incomplete': 'Incomplete'
    }[status] || status;
  };

  const {
    connectionStatus,
    messageAll,
    messageSend,
    sendMessage,
    getMessages
  } = useWebSocket({
    userId: vendorId,
    orgId: vendorId
  });

  const fetchAiSummary = async () => {
    if (!vendorId || !assessmentId) return;
    
    setIsLoadingAiSummary(true);
    try {
      const response = await axios.get(`https://api.brandsek.com/api/tprm/vendors/${vendorId}/question-forms/${assessmentId}/ai-summary`);
      if (response.data.error) {
        throw new Error(response.data.userMessage);
      }
      setAiSummary(response.data.data);
    } catch (err) {
      // console.error removed
      toastr.error('Error', 'Failed to load AI analysis summary');
    } finally {
      setIsLoadingAiSummary(false);
    }
  };

  const refreshAiAnalysis = async () => {
    if (!vendorId || !assessmentId) return;
    
    setIsLoadingAiSummary(true);
    try {
      const response = await axios.put(`https://api.brandsek.com/api/tprm/vendors/${vendorId}/question-forms/${assessmentId}/ai-summary/refresh`);
      if (response.data.error) {
        throw new Error(response.data.userMessage);
      }
      // After successful refresh, fetch the updated summary
      await fetchAiSummary();
      toastr.success('Success', 'AI analysis refreshed successfully');
    } catch (err) {
      // console.error removed
      toastr.error('Error', 'Failed to refresh AI analysis');
      setIsLoadingAiSummary(false);
    }
  };

  useEffect(() => {
    const fetchCategories = async () => {
      if (!vendorId || !assessmentId) return;

      try {
        const response = await axios.get(`/api/tprm/${vendorId}/question-forms/${assessmentId}/categories`);
        if (response.data.error) {
          throw new Error(response.data.userMessage);
        }
        
        const formattedSections = response.data.data.categories.map((category, index) => ({
          id: category.categoryId,
          number: index + 1,
          title: category.categoryName,
          status: category.status.includes("Processing") ? "Processing" : category?.status?.[0],
          questions: category.totalQuestions,
          complete: !category.status.some(s => s.includes("Flagged")),
          flagged: category.status[0] ? parseInt(category.status[0]) : 0,
          message: (category.status[0] || "") + " " + (category.status[1] || "")
        }));
        
        setSections(formattedSections);
        setFilteredSections(formattedSections);
        if (formattedSections.length > 0) {
          setSelectedSection(formattedSections[0].id);
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, [vendorId, assessmentId]);

  useEffect(() => {
    const fetchQuestions = async () => {
      if (!selectedSection || !vendorId || !assessmentId) return;
      
      setQuestionLoading(true);
      try {
        const baseUrl = `${API_URL}/tprm/vendors/${vendorId}/question-forms/${assessmentId}`;
        let url = `${baseUrl}?page=${currentPage}${selectedSection ? `&formCategoryId=${selectedSection}` : ''}`;
        
        // Add filter parameters based on the selected filter
        if (showOnlyFlagged) {
          url += '&onlyFlaggedAsRisk=true';
        } else if (isCompleted) {
          url += '&onlyIncompleteResponses=true';
        }
        
        const response = await axios.get(url);
        if (response.data.error) {
          throw new Error(response.data.userMessage);
        }

        // Handle case when data is empty or null
        if (!response.data.data) {
          setQuestions([]);
          setTotalPages(1);
          setTotalItems(0);
          return;
        }

        const questionForm = response.data.data.questionForm;
        
        // Handle case when questionForm is undefined
        if (!questionForm || !questionForm.form) {
          setQuestions([]);
          setTotalPages(1);
          setTotalItems(0);
          return;
        }

        // Set organization data with null checks
        setAssignerOrganisationName(questionForm?.assignerOrganisationId || '');
        setAssigneeOrganisationId(questionForm?.assigneeOrganisationId || '');

        // Find category questions with null checks
        const category = questionForm.form.find(
          category => category.id === selectedSection
        );
        const categoryQuestions = category?.categoryQuestions || [];

        setQuestions(categoryQuestions);
        
        // Handle null totalPages
        setTotalPages(response.data.data.totalPages || 1);
        setTotalItems(response.data.data.totalQuestions || 0);

        // Reset current page if it's greater than total pages
        if (currentPage > (response.data.data.totalPages || 1)) {
          setCurrentPage(1);
        }

        // Fetch organization data only if we have a valid ID
        if (questionForm?.assigneeOrganisationId) {
          fetchOrganizationData(questionForm.assigneeOrganisationId);
        }
      } catch (err) {
        // console.error removed
        setError(err.message || 'Failed to fetch questions');
        setQuestions([]);
        setTotalPages(1);
        setTotalItems(0);
      } finally {
        setQuestionLoading(false);
      }
    };

    fetchQuestions();
  }, [selectedSection, currentPage, showOnlyFlagged, vendorId, assessmentId]);

  const fetchOrganizationData = async (orgId) => {
    if (!orgId) return;
    
    setIsLoadingOrg(true);
    try {
      const response = await axios.get(`https://api.brandsek.com/api/customer/${orgId}`);
      if (response.data.error) {
        throw new Error(response.data.userMessage);
      }
      setOrganizationData(response.data.data[0]);
    } catch (err) {
      // console.error removed
      toastr.error('Error', 'Failed to load organization information');
    } finally {
      setIsLoadingOrg(false);
    }
  };

  useEffect(() => {
    if (searchQuery.trim() === "") {
      setFilteredSections(sections);
    } else {
      const filtered = sections.filter(section => 
        section.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
        section.number.toString().includes(searchQuery)
      );
      setFilteredSections(filtered);
    }
  }, [searchQuery, sections]);

  const handleSectionSelect = (sectionId) => {
    setSelectedSection(sectionId);
    setCurrentPage(1); // Reset to first page when changing sections
  };

  const handleFlaggedFilter = (e) => {
    const selectedValue = e.target.value;
    setSelectedFilter(selectedValue);
    
    if (selectedValue === "All Sections") {
      setShowOnlyFlagged(false);
      setIsCompleted(false);
    } else if (selectedValue === "Flagged Sections") {
      setShowOnlyFlagged(true);
      setIsCompleted(false);
    } else if (selectedValue === "Incomplete Sections") {
      setShowOnlyFlagged(false);
      setIsCompleted(true);
    }
    
    setCurrentPage(1); // Reset to first page when changing filters
  };

  const handleExport = async () => {
    if (!vendorId || !assessmentId) return;

    try {
      const response = await axios.get(
        `https://api.brandsek.com/api/tprm/vendors/${vendorId}/question-forms/${assessmentId}/excel`,
        {
          responseType: 'blob' // Important for handling file download
        }
      );

      // Create a blob from the response data
      const blob = new Blob([response.data], { 
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
      });

      // Create a URL for the blob
      const url = window.URL.createObjectURL(blob);

      // Create a temporary link element
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `risk-assessment-${assessmentId}.xlsx`);

      // Append to body, click, and remove
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Clean up the URL
      window.URL.revokeObjectURL(url);
    } catch (error) {
      // console.error removed
      // You might want to show an error message to the user here
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('files', file);

    uploadImageInChat(formData)
      .then(response => {
        setFileSent(response);
        setSelectedFile(file);
      })
      .catch(error => {
        // console.error removed
      });
  };

  const sendMessages = () => {
    if (messageInput == "") {
      toastr.error("Please enter the message.");
      return;
    }
    sendMessage({
      messageText: messageInput,
      questionFormId: assessmentId,
      questionCategoryId: categoryId,
      questionId: questionId,
      toOrganisationId: assigneeOrganisationId,
      ...(fileSent?.data && {
        attachedFiles: fileSent?.data
      })
    });
    setMessageInput("");
    setFileSent("");
    setSelectedFile("");
    const chatContainer = document.querySelector('.chatBoxMain');
    if (chatContainer) {
      chatContainer.scrollTop = chatContainer.scrollHeight;
    }
  };

  const chatOpenBox = async (categoryName, question, categoryId, event) => {
    // If chat is already open for this question, close it
    if (questionId === question?.id && chatData.length > 0) {
      setChatData([]);
      setQuestionId("");
      setCategoryId("");
      setIsChatMinimized(false);
      return;
    }

    // Get the clicked question's container element
    const questionElement = event.target.closest('.sqr-question-card');
    const questionRect = questionElement.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    getMessages({
      organisationId: vendorId,
      questionCategoryId: categoryId,
      questionFormId: assessmentId,
      questionId: question?.id
    });
    setCategoryId(categoryId);
    setQuestionId(question?.id);
    setChatData([categoryName, question, categoryId]);
    setIsChatMinimized(false);

    // Increased the offset from 20px to 50px to move the chat panel higher up
    const chatTop = questionRect.top + scrollTop - 250;
    document.documentElement.style.setProperty('--chat-top-position', `${chatTop}px`);
  };

  const openRiskModal = (question) => {
    setQuestionId(question?.id);
    setCategoryId(selectedSection);
    setRiskTitle(question?.riskAnalysis?.title || '');
    setRiskNote(question?.riskAnalysis?.comments || '');
    setRiskLevel(question?.riskAnalysis?.riskLevel || 'low');
    setRiskRecommendation(question?.riskAnalysis?.recomendation || '');
    setShowRiskBox(true);
  };

  const closeRiskModal = () => {
    setRiskLevel("low");
    setRiskNote("");
    setRiskTitle("");
    setQuestionId("");
    setShowRiskBox(false);
  };

  const saveRisk = () => {
    if (riskTitle == "") {
      toastr.error("Title is required");
      return;
    }
    if (riskLevel == "") {
      toastr.error("Risk Level is required");
      return;
    }
    if (riskNote == "") {
      toastr.error("Comment is required");
      return;
    }
    let data = {
      categoryId,
      questionId,
      riskNote,
      riskLevel,
      recomendation: riskRecommendation,
      title: riskTitle,
    };
    addRiskRegister(vendorId, assessmentId, data, null, closeRiskModal);
  };

  useEffect(() => {
    const chatContainer = document.querySelector('.chatBoxMain');
    if (chatContainer && messageAll?.length > 0) {
      chatContainer.scrollTop = chatContainer.scrollHeight;
    }
  }, [messageAll]);

  // Add these functions for approve/reject handling
  const handleRouteChange = () => history.push('/tprm/assessment-campaign');
  const approveBtn = (id) => approveReview(vendorId, id, [], handleRouteChange);
  const rejectBtn = () => {
    axios.post(`/api/tprm/${vendorId}/question-forms/${assessmentId}/reject`)
      .then(() => {
        toastr.success('Success', 'Questionnaire form rejected successfully');
        handleRouteChange();
      })
      .catch((error) => {
        // console.error removed
        toastr.error('Error', 'Failed to reject questionnaire form');
      });
  };

  const confirmApprove = () => {
    approveBtn(assessmentId);
    setShowApproveConfirm(false);
  };

  const confirmReject = () => {
    rejectBtn();
    setShowRejectConfirm(false);
  };

  const handleMarkIncomplete = async () => {
    if (!incompleteReason.trim()) {
      toastr.error('Error', 'Please provide a reason for marking as incomplete');
      return;
    }

    if (!vendorId || !assessmentId) {
      toastr.error('Error', 'Missing required information');
      return;
    }

    setIsMarkingIncomplete(true);
    try {
      const session = localStorage.getItem('session');
      const response = await axios.post(
        `https://api.brandsek.com/api/tprm/${vendorId}/question-forms/${assessmentId}/incomplete`,
        { reason: incompleteReason.trim() },
        {
          headers: {
            'Authorization': `Bearer ${session}`,
            'Content-Type': 'application/json'
          }
        }
      );

      if (response.data.error) {
        throw new Error(response.data.userMessage || 'Failed to mark as incomplete');
      }

      toastr.success('Success', 'Assessment marked as incomplete successfully');
      setShowIncompleteModal(false);
      setIncompleteReason("");
      // Optionally refresh the page or update state
      // handleRouteChange();
    } catch (err) {
      const errorMessage = err.response?.data?.userMessage || err.message || 'Failed to mark as incomplete';
      toastr.error('Error', errorMessage);
    } finally {
      setIsMarkingIncomplete(false);
    }
  };

  useEffect(() => {
    fetchAiSummary();
  }, [vendorId, assessmentId]);

  const parseMarkdown = (text) => {
    if (!text) return '';
    
    // Convert markdown links to HTML
    text = text.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>');
    
    // Convert bold text with a different class
    text = text.replace(/\*\*([^*]+)\*\*/g, '<span class="content-bold">$1</span>');
    
    // Convert italic text
    text = text.replace(/\*([^*]+)\*/g, '<em>$1</em>');
    
    // Convert bullet points
    text = text.replace(/^\s*[-*+]\s+(.+)$/gm, '<li>$1</li>');
    text = text.replace(/(<li>.*<\/li>)/s, '<ul>$1</ul>');
    
    // Convert numbered lists
    text = text.replace(/^\s*\d+\.\s+(.+)$/gm, '<li>$1</li>');
    text = text.replace(/(<li>.*<\/li>)/s, '<ol>$1</ol>');
    
    // Convert line breaks
    text = text.replace(/\n/g, '<br />');
    
    return text;
  };

  return (
    <div className="sqr-container">
      <div className="sqr-header">
        <h1 className="sqr-title">
          {isLoadingOrg ? (
            <span>Loading organization info...</span>
          ) : (
            `${organizationData?.orgName || 'Organization'} - Security Questionnaire Review`
          )}
        </h1>
        <p className="sqr-subtitle">AI-assisted review of vendor's completed TPRM questionnaire</p>
        
        <div className="sqr-actions">
          <button 
            className="sqr-btn sqr-btn-outline"
            onClick={handleExport}
            disabled={!vendorId || !assessmentId}
          >
            <FontAwesomeIcon icon={faDownload} /> Export
          </button>
          {/* <button className="sqr-btn sqr-btn-primary">
            <FontAwesomeIcon icon={faPaperPlane} /> Send Feedback
          </button> */}
          <button
            onClick={() => setShowRejectConfirm(true)}
            className="sqr-btn sqr-btn-danger"
            style={{
              padding: '8px 16px',
              borderRadius: '6px',
              border: 'none',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              backgroundColor: '#dc3545',
              color: 'white',
              marginLeft: '10px'
            }}
          >
            Reject
          </button>
          <button
            onClick={() => setShowIncompleteModal(true)}
            className="sqr-btn sqr-btn-warning"
            style={{
              padding: '8px 16px',
              borderRadius: '6px',
              border: 'none',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              backgroundColor: '#ffc107',
              color: '#212529',
              marginLeft: '10px'
            }}
          >
            Mark as Incomplete
          </button>
          <button
            onClick={() => setShowApproveConfirm(true)}
            className="sqr-btn sqr-btn-success"
            style={{
              padding: '8px 16px',
              borderRadius: '6px',
              border: 'none',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              backgroundColor: '#28a745',
              color: 'white',
              marginLeft: '10px'
            }}
          >
            Complete Assessment
          </button>
        </div>
      </div>

      <div className="sqr-vendor-info-card">
        <div className="sqr-vendor-info-content">
          <div className="sqr-vendor-logo">
            <div className="sqr-logo-placeholder">
              {isLoadingOrg ? (
                <div className="loading-spinner" />
              ) : organizationData?.logoUrl ? (
                <img src={organizationData.logoUrl} alt={organizationData.orgName} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
              ) : (
                <FontAwesomeIcon icon={faFile} />
              )}
            </div>
          </div>
          <div className="sqr-vendor-details">
            <h2 className="sqr-vendor-name">
              {isLoadingOrg ? 'Loading...' : (organizationData?.orgName || vendorInfo?.name)}
            </h2>
            <p className="sqr-vendor-type">
              {isLoadingOrg ? 'Loading...' : (
                `${organizationData?.industryType || vendorInfo?.type} | 
                Criticality: ${organizationData?.criticality || vendorInfo?.dataClassification}`
              )}
            </p>
            {/* <div className="sqr-vendor-frameworks">
              {!isLoadingOrg && organizationData?.vendorProfile?.domains?.map((domain, index) => (
                <span key={index} className="sqr-framework-badge">{domain.replace(/_/g, ' ')}</span>
              ))}
            </div> */}
          </div>
          <div className="sqr-vendor-meta">
            <div className="sqr-risk-score">
              <label>Risk Score:</label>
              <span className="sqr-risk-badge sqr-risk-medium">
                {isLoadingOrg ? 'Loading...' : (
                  `${organizationData?.vendorProfile?.tier || 'Medium'} (${vendorInfo?.riskScore}/100)`
                )}
              </span>
            </div>
            <div className="sqr-dates">
              <div>Questionnaire submitted: {vendorInfo?.submittedDate}</div>
              <div>Review deadline: {vendorInfo?.reviewDeadline}</div>
            </div>
          </div>
        </div>
      </div>

      <div className="sqr-ai-summary-card">
        <div className="sqr-ai-header">
          <div className="sqr-ai-icon">
            <FontAwesomeIcon icon={faLightbulb} />
          </div>
          <h3 className="sqr-ai-title">CTEM Insights Summary</h3>
        </div>
        <p className="sqr-ai-description">
          The AI has analyzed the questionnaire responses against your security requirements and industry benchmarks.
        </p>

        {isLoadingAiSummary ? (
          <div className="sqr-loading">Loading AI analysis...</div>
        ) : aiSummary ? (
          <>
            <div className="sqr-metrics-container">
              <div className="sqr-metric-item">
                <div className="sqr-metric-label">Overall Confidence</div>
                <div className="sqr-metric-value">{aiSummary?.overallConfidence?.label?.charAt(0)?.toUpperCase() + aiSummary?.overallConfidence?.label?.slice(1)}
                </div>
                <div className="sqr-progress-bar">
                  <div 
                    className={`sqr-progress-fill sqr-progress-${aiSummary?.overallConfidence?.label}`}   
                    style={{width: `${aiSummary?.overallConfidence?.score}%`}}
                  ></div>
                </div>
              </div>
              <div className="sqr-metric-item">
                <div className="sqr-metric-label">Potential Issues</div>
                <div className="sqr-metric-value sqr-text-warning">{aiSummary?.potentialRisks} %</div>
                <div className="sqr-progress-bar">
                  <div 
                    className="sqr-progress-fill sqr-progress-warning" 
                    style={{width: `${Math.min(100, (aiSummary?.potentialRisks / 100) * 100)}%`}}
                  ></div>
                </div>
              </div>
              <div className="sqr-metric-item">
                <div className="sqr-metric-label">Missing Info</div>
                <div className="sqr-metric-value sqr-text-danger">{aiSummary?.missingInformations} %</div>
                <div className="sqr-progress-bar">
                  <div 
                    className="sqr-progress-fill sqr-progress-danger" 
                    style={{width: `${Math.min(100, (aiSummary?.missingInformations / 100) * 100)}%`}}
                  ></div>
                </div>
              </div>
              <div className="sqr-metric-item">
                <div className="sqr-metric-label">Compliance Match</div>
                <div className="sqr-metric-value">{aiSummary?.complianceMatch}%</div>
                <div className="sqr-progress-bar">
                  <div 
                    className="sqr-progress-fill sqr-progress-primary" 
                    style={{width: `${aiSummary?.complianceMatch}%`}}
                  ></div>
                </div>
              </div>
            </div>

            <div className="sqr-recommendation-box">
              <div className="sqr-recommendation-header">
                <div className="sqr-lightbulb-icon">
                  <FontAwesomeIcon icon={faClipboardList} />
                </div>
                <span className="sqr-recommendation-label">Recommendation</span>
              </div>
              <p className="sqr-recommendation-text" dangerouslySetInnerHTML={{ __html: parseMarkdown(aiSummary?.recomendation) }}></p>
            </div>

            <div className="sqr-analysis-meta">
              <div className="sqr-analysis-timing">
                <span className="sqr-timing-icon"></span>
                Last updated {moment(aiSummary?.updatedAt).fromNow()}
              </div>
              <button 
                className="sqr-refresh-btn"
                onClick={() => {
                  refreshAiAnalysis();
                }}
                disabled={isLoadingAiSummary}
              >
                <FontAwesomeIcon icon={faSync} spin={isLoadingAiSummary} /> 
                {isLoadingAiSummary ? 'Refreshing...' : 'Refresh Analysis'}
              </button>
            </div>
          </>
        ) : (
          <div className="sqr-error">Loading...</div>
        )}
      </div>

      <div className="sqr-content-layout">
        <div className="sqr-sidebar">
          <div className="sqr-sidebar-header">
            <h3 className="sqr-sidebar-title">Questionnaire Sections</h3>
            <div className="sqr-dropdown">
              <select 
                className="sqr-section-filter"
                value={selectedFilter}
                onChange={handleFlaggedFilter}
              >
                <option value="All Sections">All Sections</option>
                <option value="Flagged Sections">Flagged Sections</option>
                <option value="Incomplete Sections">Incomplete Sections</option>
              </select>
            </div>
          </div>

          <div className="sqr-search-box">
            <FontAwesomeIcon icon={faSearch} className="sqr-search-icon" />
            <input 
              type="text" 
              className="sqr-search-input" 
              placeholder="Search questions..." 
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>

          {loading ? (
            <div className="sqr-loading">Loading sections...</div>
          ) : error ? (
            <div className="sqr-error">{error}</div>
          ) : (
            <>
              {filteredSections?.length === 0 ? (
                <div className="sqr-no-results">No sections found matching your search</div>
              ) : (
                <div className="sqr-section-list">
                  {filteredSections?.map(section => (
                    <div 
                      key={section.id} 
                      className={`sqr-section-item ${section.id === selectedSection ? 'sqr-section-active' : ''} ${getStatusClass(section.status)}`}
                      onClick={() => handleSectionSelect(section.id)}
                    >
                      <div className="sqr-section-info">
                        <div className="sqr-section-heading">
                          <span className="sqr-section-number">{section.number}. </span>
                          <span className="sqr-section-title">{section.title}</span>
                        </div>
                        <div className="sqr-section-meta">
                          {section.questions} questions .  {section.message}
                        </div>
                      </div>
                      <div className={`sqr-status-badge sqr-badge-${section.status}`}>
                        {getStatusBadge(section.status)}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </>
          )}
        </div>

        <div className="sqr-main-content">
          <div className="sqr-content-header">
            <h2 className="sqr-content-title">
              {sections.find(s => s.id === selectedSection)?.title || 'Select a Section'}
            </h2>
            <div className="sqr-content-nav">
              <button 
                className="sqr-nav-btn sqr-prev-btn"
                disabled={currentPage === 1}
                onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
              >
                <FontAwesomeIcon icon={faChevronLeft} />
              </button>
              <span className="sqr-page-info">Page {currentPage} of {totalPages}</span>
              <button 
                className="sqr-nav-btn sqr-next-btn"
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
              >
                <FontAwesomeIcon icon={faChevronRight} />
              </button>
            </div>
          </div>

          {questionLoading ? (
            <div className="sqr-loading">Loading questions...</div>
          ) : error ? (
            <div className="sqr-error">{error}</div>
          ) : questions?.length === 0 ? (
            <div className="sqr-no-results">No questions found for this section</div>
          ) : (
            <div className="sqr-questions-container">
              {questions?.map((question, index) => (
                <div key={question?.id} className="sqr-question-card">
                  <div className="sqr-question-header">
                    <div className="sqr-question-number">Question {index + 1}</div>
                    <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                      {question?.response?.isAutoFilled ? (
                        <div style={{
                          backgroundColor: '#f6ffed',
                          color: '#52c41a',
                          padding: '6px 12px',
                          borderRadius: '6px',
                          fontSize: '12px',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                          border: '1px solid #b7eb8f',
                          boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                        }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <FontAwesomeIcon icon={faCheck} style={{ fontSize: '12px' }} />
                            <span style={{ fontWeight: '500' }}>Previously Reviewed</span>
                          </div>
                          <div style={{ 
                            borderLeft: '1px solid #b7eb8f', 
                            paddingLeft: '8px',
                            color: '#666',
                            fontSize: '11px'
                          }}>
                            {question?.response?.lastReviewedAt ? 
                              `Last review: ${moment(question.response.lastReviewedAt).fromNow()}` : 
                              'Review history available'}
                          </div>
                        </div>
                      ) : (
                        <div style={{
                          backgroundColor: '#fff7e6',
                          color: '#fa8c16',
                          padding: '6px 12px',
                          borderRadius: '6px',
                          fontSize: '12px',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                          border: '1px solid #ffd591',
                          animation: 'pulse 2s infinite',
                          boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                        }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <FontAwesomeIcon icon={faExclamationCircle} style={{ fontSize: '12px' }} />
                            <span style={{ fontWeight: '500' }}>New Question</span>
                          </div>
                          <div style={{ 
                            borderLeft: '1px solid #ffd591', 
                            paddingLeft: '8px',
                            color: '#666',
                            fontSize: '11px'
                          }}>
                            {question?.response?.submittedAt ? 
                              `Submitted ${moment(question.response.submittedAt).fromNow()}` : 
                              'Awaiting review'}
                          </div>
                        </div>
                      )}
                      {question?.response?.isAutoFilled && question?.response?.lastReviewedBy && (
                        <div style={{
                          backgroundColor: '#f0f5ff',
                          color: '#2f54eb',
                          padding: '6px 12px',
                          borderRadius: '6px',
                          fontSize: '12px',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                          border: '1px solid #adc6ff',
                          boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                        }}>
                          <FontAwesomeIcon icon={faUser} style={{ fontSize: '12px' }} />
                          <span>Reviewed by {question.response.lastReviewedBy}</span>
                        </div>
                      )}
                      {!question?.response?.isAutoFilled && (
                        <div style={{
                          backgroundColor: '#f9f0ff',
                          color: '#722ed1',
                          padding: '6px 12px',
                          borderRadius: '6px',
                          fontSize: '12px',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                          border: '1px solid #d3adf7',
                          boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                        }}>
                          <FontAwesomeIcon icon={faClock} style={{ fontSize: '12px' }} />
                          <span>Priority Review Required</span>
                        </div>
                      )}
                    </div>
                  </div>

                  <div style={{ display: 'flex', gap: '20px' }}>
                    <div style={{ flex: 1 }}>
                      <div className="sqr-question-content">
                        <div className="sqr-question-text">{question?.question_text}</div>
                      </div>

                      <div className="sqr-response-section">
                        <div className="sqr-response-header">
                          <div className="sqr-response-icon">
                            <FontAwesomeIcon icon={faFile} />
                          </div>
                          <div className="sqr-response-label">Vendor Response:</div>
                        </div>
                        <div className="sqr-response-content">
                          <p>{question?.response?.value || 'No response'}</p>
                          <p>{question?.response?.comment}</p>
                        </div>
                      </div>

                      {question?.response?.evidences && question?.response?.evidences?.length > 0 && (
                        <div className="sqr-evidence-section">
                          <div className="sqr-response-header">
                            <div className="sqr-response-icon">
                              <FontAwesomeIcon icon={faPaperclip} />
                            </div>
                            <div className="sqr-response-label">Attached Evidence:</div>
                          </div>
                          <div className="sqr-evidence-list">
                            {question?.response?.evidences?.map((evidence, index) => (
                              <a 
                                key={index} 
                                href={evidence.signedUrl} 
                                className="sqr-evidence-link"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <FontAwesomeIcon icon={faFile} className="sqr-file-icon" />
                                {evidence.fileKey || evidence.fileName}
                              </a>
                            ))}
                          </div>
                        </div>
                      )}

                      {question?.analyseResponseRiskStatus == "completed" ? (
                        <div className="sqr-ai-analysis-section">
                          {question.analyseResponseRiskStatus == 'completed' && question.riskAnalysis && Object.keys(question.riskAnalysis).length > 0 ? (
                            <>
                              <div className="sqr-ai-analysis-header">
                                <div className="sqr-ai-icon-large">
                                  <FontAwesomeIcon icon={faLightbulb} />
                                </div>
                                <div className="sqr-ai-header-label">CTEM Insights:</div>
                              </div>
                              
                              {question.riskAnalysis.hasRisk === true ? (
                                // Risk Detected - Show warning styling
                                <div className="sqr-ai-analysis-content" style={{
                                  border: '1px solid #ff4d4f',
                                  backgroundColor: '#fff1f0',
                                  borderRadius: '8px',
                                  padding: '16px',
                                  marginTop: '12px'
                                }}>
                                  <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px',
                                    marginBottom: '12px',
                                    color: '#ff4d4f'
                                  }}>
                                    <FontAwesomeIcon icon={faExclamationTriangle} style={{ fontSize: '16px' }} />
                                    <h4 style={{ margin: 0, color: '#ff4d4f' }}>Risk Detected</h4>
                                  </div>
                                  <div className="sqr-risk-details">
                                    {question.riskAnalysis.title && (
                                      <h5 style={{ color: '#333', marginBottom: '8px' }}>{question.riskAnalysis.title}</h5>
                                    )}
                                    {question.riskAnalysis.riskLevel && question.riskAnalysis.riskLevel !== "none" && (
                                      <p style={{ marginBottom: '8px' }}>
                                        <strong style={{ color: '#ff4d4f' }}>Risk Level:</strong> 
                                        <span style={{
                                          padding: '4px 8px',
                                          borderRadius: '4px',
                                          fontSize: '12px',
                                          fontWeight: '500',
                                          marginLeft: '8px',
                                          backgroundColor: question.riskAnalysis.riskLevel === 'critical' ? '#ff4d4f' : 
                                                         question.riskAnalysis.riskLevel === 'high' ? '#fa8c16' :
                                                         question.riskAnalysis.riskLevel === 'medium' ? '#faad14' : '#52c41a',
                                          color: 'white'
                                        }}>
                                          {question.riskAnalysis.riskLevel.toUpperCase()}
                                        </span>
                                      </p>
                                    )}
                                    <div className="analysis-section">
                                      <div className="analysis-label" style={{ color: '#ff4d4f', fontWeight: '600' }}>Risk Analysis:</div>
                                      <div className="analysis-content" dangerouslySetInnerHTML={{ __html: parseMarkdown(question.riskAnalysis.comments) }} />
                                    </div>
                                    {question.riskAnalysis.recomendation && (
                                      <div className="analysis-section">
                                        <div className="analysis-label" style={{ color: '#ff4d4f', fontWeight: '600' }}>Recommendation:</div>
                                        <div className="analysis-content" dangerouslySetInnerHTML={{ __html: parseMarkdown(question.riskAnalysis.recomendation) }} />
                                      </div>
                                    )}
                                    {question.riskAnalysis.module && question.riskAnalysis.module !== "none" && (
                                      <div style={{ marginTop: '15px' }}>
                                        <button
                                          onClick={() => {
                                            let redirectUrl = '';
                                            switch(question.riskAnalysis.module) {
                                              case 'assets':
                                                redirectUrl = `/assets/vendor/${assigneeOrganisationId}`;
                                                break;
                                              case 'Assets':
                                                redirectUrl = `/assets/vendor/${assigneeOrganisationId}`;
                                                break;
                                              case 'high-risk-vulnerability':
                                                redirectUrl = `/known-vulnerabilities/vendor/${assigneeOrganisationId}`;
                                                break;
                                              case 'personal-information-breach':
                                                redirectUrl = `/pii/vendor/${assigneeOrganisationId}`;
                                                break;
                                              case 'expired-ssl-certificate':
                                                redirectUrl = `/vulnerable-certificates/vendor/${assigneeOrganisationId}`;
                                                break;
                                              case 'vulnerable-ssl-certificate':
                                                redirectUrl = `/vulnerable-certificates/vendor/${assigneeOrganisationId}`;
                                                break;
                                              default:
                                                return;
                                            }
                                            if (redirectUrl) {
                                              window.open(redirectUrl, '_blank');
                                            }
                                          }}
                                          style={{
                                            padding: '8px 16px',
                                            backgroundColor: '#ff4d4f',
                                            color: 'white',
                                            border: 'none',
                                            borderRadius: '6px',
                                            cursor: 'pointer',
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            gap: '10px',
                                            transition: 'all 0.2s ease',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            lineHeight: '1.5',
                                            minWidth: '200px',
                                            justifyContent: 'center'
                                          }}
                                          onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#ff7875'}
                                          onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#ff4d4f'}
                                        >
                                          <FontAwesomeIcon icon={faFile} style={{ fontSize: '14px' }} />
                                          View Continuous Monitoring Data
                                        </button>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              ) : (
                                // No Risk Detected - Show success styling
                                <div className="sqr-ai-analysis-content" style={{
                                  border: '1px solid #52c41a',
                                  backgroundColor: '#f6ffed',
                                  borderRadius: '8px',
                                  padding: '16px',
                                  marginTop: '12px'
                                }}>
                                  <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px',
                                    marginBottom: '12px',
                                    color: '#52c41a'
                                  }}>
                                    <FontAwesomeIcon icon={faCheck} style={{ fontSize: '16px' }} />
                                    <h4 style={{ margin: 0, color: '#52c41a' }}>No Risk Detected</h4>
                                  </div>
                                  <div className="sqr-risk-details">
                                    {question.riskAnalysis.title && (
                                      <h5 style={{ color: '#333', marginBottom: '8px' }}>{question.riskAnalysis.title}</h5>
                                    )}
                                    <div className="analysis-section">
                                      <div className="analysis-label" style={{ color: '#52c41a', fontWeight: '600' }}>Analysis:</div>
                                      <div className="analysis-content" dangerouslySetInnerHTML={{ __html: parseMarkdown(question.riskAnalysis.comments) }} />
                                    </div>
                                    {question.riskAnalysis.recomendation && (
                                      <div className="analysis-section">
                                        <div className="analysis-label" style={{ color: '#52c41a', fontWeight: '600' }}>Recommendation:</div>
                                        <div className="analysis-content" dangerouslySetInnerHTML={{ __html: parseMarkdown(question.riskAnalysis.recomendation) }} />
                                      </div>
                                    )}
                                    {question.riskAnalysis.module && question.riskAnalysis.module !== "none" && (
                                      <div style={{ marginTop: '15px' }}>
                                        <button
                                          onClick={() => {
                                            let redirectUrl = '';
                                            switch(question.riskAnalysis.module) {
                                              case 'assets':
                                                redirectUrl = `/assets/vendor/${assigneeOrganisationId}`;
                                                break;
                                              case 'high-risk-vulnerability':
                                                redirectUrl = `/known-vulnerabilities/vendor/${assigneeOrganisationId}`;
                                                break;
                                              case 'personal-information-breach':
                                                redirectUrl = `/pii/vendor/${assigneeOrganisationId}`;
                                                break;
                                              case 'expired-ssl-certificate':
                                                redirectUrl = `/vulnerable-certificates/vendor/${assigneeOrganisationId}`;
                                                break;
                                              default:
                                                return;
                                            }
                                            if (redirectUrl) {
                                              window.open(redirectUrl, '_blank');
                                            }
                                          }}
                                          style={{
                                            padding: '8px 16px',
                                            backgroundColor: '#52c41a',
                                            color: 'white',
                                            border: 'none',
                                            borderRadius: '6px',
                                            cursor: 'pointer',
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            gap: '10px',
                                            transition: 'all 0.2s ease',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            lineHeight: '1.5',
                                            minWidth: '200px',
                                            justifyContent: 'center'
                                          }}
                                          onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#73d13d'}
                                          onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#52c41a'}
                                        >
                                          <FontAwesomeIcon icon={faFile} style={{ fontSize: '14px' }} />
                                          View Continuous Monitoring Data
                                        </button>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              )}
                            </>
                          ) : (
                            <div className="sqr-ai-analysis-loading" style={{
                              padding: '20px',
                              textAlign: 'center',
                              color: '#666',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: '10px'
                            }}>
                               <FontAwesomeIcon icon={faFile} style={{ fontSize: '20px', color: '#6563ff' }} />
                              <span>No response from vendor</span>
                            </div>
                          )}
                        </div>
                      ) : (
                        <div className="sqr-ai-analysis-loading" style={{
                          padding: '20px',
                          textAlign: 'center',
                          color: '#666',
                        }}>
                          {question?.riskAnalysis && Object.keys(question?.riskAnalysis).length > 0 && question?.analyseResponseRiskStatus == 'completed'}
                          <FontAwesomeIcon icon={faRobot} style={{ fontSize: '20px', color: '#6563ff' }} />
                          <span>                         
                          AI Analysis {question.analyseResponseRiskStatus === 'pending' ? 'Pending' : 'In Progress'}...</span>
                        </div>
                      )}

                      <div className="sqr-question-actions" style={{ 
                        marginTop: '20px', 
                        paddingTop: '15px', 
                        borderTop: '1px solid #eee',
                        display: 'flex',
                        gap: '15px'
                      }}>
                        <button
                          onClick={(event) => chatOpenBox(
                            sections.find(s => s.id === selectedSection)?.title,
                            question,
                            selectedSection,
                            event
                          )}
                          className="sqr-action-btn"
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            padding: '8px 16px',
                            border: question.followupChatStats?.unseenMessages > 0 ? '2px solid #ff4d4f' : '1px solid #6563ff',
                            borderRadius: '6px',
                            background: questionId === question?.id && chatData.length > 0 ? '#6563ff' : 
                              question.followupChatStats?.unseenMessages > 0 ? '#ff4d4f' : '#6563ff',
                            color: '#ffffff',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                            position: 'relative'
                          }}
                          onMouseOver={(e) => {
                            if (questionId === question?.id && chatData.length > 0) {
                              e.currentTarget.style.background = '#5251cc';
                            } else {
                              e.currentTarget.style.background = question.followupChatStats?.unseenMessages > 0 ? '#ff7875' : '#5251cc';
                            }
                          }}
                          onMouseOut={(e) => {
                            if (questionId === question?.id && chatData.length > 0) {
                              e.currentTarget.style.background = '#6563ff';
                            } else {
                              e.currentTarget.style.background = question.followupChatStats?.unseenMessages > 0 ? '#ff4d4f' : '#6563ff';
                            }
                          }}
                        >
                          <FontAwesomeIcon icon={faComment} />
                          <span style={{ color: '#ffffff' }}>Follow-up</span>
                          {question.followupChatStats && (
                            <>
                              {question.followupChatStats.totalMessages > 0 && !question.followupChatStats.unseenMessages && (
                                <span style={{
                                  position: 'absolute',
                                  top: '-8px',
                                  right: '-8px',
                                  backgroundColor: '#6563ff',
                                  color: 'white',
                                  borderRadius: '50%',
                                  width: '20px',
                                  height: '20px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  fontSize: '12px',
                                  fontWeight: 'bold'
                                }}>
                                  {question.followupChatStats.totalMessages}
                                </span>
                              )}
                              {question.followupChatStats.unseenMessages > 0 && (
                                <span style={{
                                  position: 'absolute',
                                  top: '-8px',
                                  right: '-8px',
                                  backgroundColor: '#ff4d4f',
                                  color: 'white',
                                  borderRadius: '50%',
                                  width: '20px',
                                  height: '20px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  fontSize: '12px',
                                  fontWeight: 'bold',
                                  animation: 'pulse 2s infinite',
                                  boxShadow: '0 0 0 rgba(255, 77, 79, 0.4)'
                                }}>
                                  {question.followupChatStats.unseenMessages}
                                </span>
                              )}
                            </>
                          )}
                        </button>

                        <button
                          onClick={(event) => openRiskModal(question)}
                          className="sqr-action-btn"
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            padding: '8px 16px',
                            border: '1px solid #ff4d4f',
                            borderRadius: '6px',
                            background: 'transparent',
                            color: '#ff4d4f',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease'
                          }}
                          onMouseOver={(e) => e.currentTarget.style.background = '#fff1f0'}
                          onMouseOut={(e) => e.currentTarget.style.background = 'transparent'}
                        >
                          <FontAwesomeIcon icon={faExclamationTriangle} />
                          <span>Raise Risk</span>
                        </button>
                      </div>

                      <style>
                        {`
                          @keyframes pulse {
                            0% {
                              box-shadow: 0 0 0 0 rgba(250, 140, 22, 0.4);
                            }
                            70% {
                              box-shadow: 0 0 0 6px rgba(250, 140, 22, 0);
                            }
                            100% {
                              box-shadow: 0 0 0 0 rgba(250, 140, 22, 0);
                            }
                          }
                          .analysis-section {
                            margin: 10px 0;
                          }
                          .analysis-label {
                            font-weight: 600;
                            color: #333;
                            margin-bottom: 5px;
                          }
                          .analysis-content {
                            color: #666;
                            line-height: 1.5;
                          }
                          .analysis-content .content-bold {
                            font-weight: 600;
                            color: #444;
                          }
                          .analysis-content ul, .analysis-content ol {
                            margin: 8px 0;
                            padding-left: 20px;
                          }
                          .analysis-content li {
                            margin: 4px 0;
                          }
                          .analysis-content a {
                            color: #6563ff;
                            text-decoration: none;
                          }
                          .analysis-content a:hover {
                            text-decoration: underline;
                          }
                          div[title]:hover > div {
                            opacity: 1;
                          }
                          .sqr-question-card {
                            background: #fff;
                            border-radius: 8px;
                            padding: 16px;
                            margin-bottom: 16px;
                            box-shadow: 0 2px 8px rgba(0,0,0,0.05);
                            transition: all 0.3s ease;
                          }
                          .sqr-question-card:hover {
                            box-shadow: 0 4px 12px rgba(0,0,0,0.1);
                          }
                          .sqr-question-header {
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            margin-bottom: 12px;
                            padding-bottom: 12px;
                            border-bottom: 1px solid #f0f0f0;
                          }
                          .sqr-question-number {
                            font-size: 14px;
                            font-weight: 500;
                            color: #333;
                          }
                        `}
                      </style>
                    </div>

                    {question.policyCertificatesAndControlsClassification && question.policyCertificatesAndControlsClassification.length > 0 && (
                      <div style={{ width: '250px', fontSize: '13px', color: '#666' }}>
                        <div style={{ marginBottom: '8px', fontWeight: '600', color: '#333' }}>
                          <FontAwesomeIcon icon={faFile} style={{ marginRight: '6px' }} />
                          Certification Mappings
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                          {question.policyCertificatesAndControlsClassification.map((cert, index) => (
                            <div key={index} style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                              <div style={{ fontWeight: '500', color: '#444' }}>{cert.certificate}</div>
                              <div style={{ paddingLeft: '8px' }}>
                                {cert.controls.map((control, ctrlIndex) => (
                                  <div key={ctrlIndex} style={{ fontSize: '12px', color: '#666' }}>
                                    {control}
                                  </div>
                                ))}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Remove the Approve/Reject buttons from the bottom */}
          <div className="dataTables_paginate ml-2 d-flex justify-content-end align-items-center mt-4">
            {totalItems > 0 && (
              <Pagination
                className="pagination-bar"
                currentPage={currentPage}
                totalCount={totalItems}
                pageSize={10}
                onPageChange={(page) => setCurrentPage(page)}
              />
            )}
          </div>
        </div>
      </div>

      {/* Chat Panel */}
      {chatData.length > 0 && !isChatMinimized && (
        <div className="chat-panel"
          style={{
            position: 'fixed',
            right: '20px',
            top: '20px',
            width: '30%',
            maxWidth: '450px',
            minWidth: '250px',
            backgroundColor: '#ffffff',
            border: '1px solid #e0e0e0',
            borderRadius: '8px',
            boxShadow: '0 0 10px rgba(0,0,0,0.1)',
            transition: 'all 0.3s ease',
            zIndex: 1000,
            display: 'flex',
            flexDirection: 'column',
            maxHeight: '80vh'
          }}>
          <div className="chat-header"
            style={{
              padding: '10px 15px',
              borderBottom: '1px solid #e0e0e0',
              display: 'flex',
              flexDirection: 'column',
              gap: '8px',
              backgroundColor: '#f8f9fa',
              borderTopLeftRadius: '8px',
              borderTopRightRadius: '8px'
            }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <div className="d-flex align-items-center">
                <span className="mr-2" style={{ color: '#6563ff' }}>💬</span>
                <span style={{ color: '#212529' }}>Follow-up Question</span>
              </div>
              <div style={{ cursor: 'pointer' }} onClick={() => setIsChatMinimized(true)}>
                <span style={{ color: '#6563ff' }}>▼</span>
              </div>
            </div>
            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
              {chatData[1]?.response?.isAutoFilled && (
                <div style={{
                  backgroundColor: '#e6f7ff',
                  color: '#1890ff',
                  padding: '2px 8px',
                  borderRadius: '4px',
                  fontSize: '12px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px',
                  border: '1px solid #91d5ff'
                }}>
                  <FontAwesomeIcon icon={faSync} style={{ fontSize: '10px' }} />
                  Previously reviewed
                </div>
              )}
              {chatData[1]?.riskAnalysis?.hasRisk && chatData[1]?.riskAnalysis?.isComplete && (
                <div style={{
                  backgroundColor: '#fff2e8',
                  color: '#fa541c',
                  padding: '2px 8px',
                  borderRadius: '4px',
                  fontSize: '12px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px',
                  border: '1px solid #ffbb96'
                }}>
                  <FontAwesomeIcon icon={faExclamationTriangle} style={{ fontSize: '10px' }} />
                  Risk Raised
                </div>
              )}
              {chatData[1]?.riskAnalysis?.hasRisk && !chatData[1]?.riskAnalysis?.isComplete && (
                <div style={{
                  backgroundColor: '#fff1f0',
                  color: '#ff4d4f',
                  padding: '2px 8px',
                  borderRadius: '4px',
                  fontSize: '12px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px',
                  border: '1px solid #ffccc7'
                }}>
                  <FontAwesomeIcon icon={faRobot} style={{ fontSize: '10px' }} />
                  AI Flagged
                </div>
              )}
            </div>
          </div>

          <div className="chatBoxMain"
            style={{
              flex: 1,
              overflowY: 'auto',
              padding: '15px',
              backgroundColor: '#ffffff'
            }}>
            <div className="question-context"
              style={{
                backgroundColor: '#f8f9fa',
                padding: '15px',
                borderRadius: '8px',
                marginBottom: '15px',
                border: '1px solid #e0e0e0'
              }}>
              <small style={{ color: '#212529' }}>Original Question:</small>
              <p className="mb-1" style={{ color: '#212529' }}>{chatData[1]?.question_text}</p>
              <small style={{ color: '#212529' }}>Answer:</small>
              <p style={{ color: '#212529' }}>{chatData[1]?.response?.value || 'No response'}</p>
            </div>

            {messageAll?.map((r) => (
              <div
                className={r?.type == "sent" ? "boxCChat" : "boxBChat"}
                key={r?.id || r?.createdAt}
                style={{
                  marginBottom: '15px',
                  padding: '10px 15px',
                  borderRadius: '8px',
                  backgroundColor: r?.type == "sent" ? '#f0f2ff' : '#f8f9fa',
                  border: '1px solid #e0e0e0'
                }}
              >
                <p style={{ color: '#212529', marginBottom: '5px' }}>
                  {r?.messageText}
                </p>
                {r?.attachedFiles && (
                  <>
                    {r?.attachedFiles[0]?.fileType?.startsWith('image/') ? (
                      <img
                        src={r?.attachedFiles[0]?.signedUrl}
                        className="img-fluid imgChatSend"
                        alt="chat attachment"
                        style={{ maxWidth: '200px', borderRadius: '4px' }}
                      />
                    ) : (
                      <div className="file-download-section">
                        <a
                          href={r?.attachedFiles[0]?.signedUrl}
                          target="_blank"
                          download={r?.attachedFiles[0]?.fileName}
                          className="download-link"
                          style={{ color: '#212529', textDecoration: 'none' }}
                        >
                          📎 {r?.attachedFiles[0]?.fileName}
                        </a>
                      </div>
                    )}
                  </>
                )}
                <p className="recieveTime" style={{ fontSize: '12px', color: '#212529', marginTop: '5px' }}>
                  {moment(r?.createdAt).format("DD-MM-YYYY || HH:mm")}
                </p>
              </div>
            ))}
          </div>

          <div className="chat-input"
            style={{
              borderTop: '1px solid #e0e0e0',
              padding: '10px',
              backgroundColor: '#ffffff',
              borderBottomLeftRadius: '8px',
              borderBottomRightRadius: '8px'
            }}>
            <div className="d-flex align-items-center w-100">
              <div className="ReplyBox w-100">
                <div className="input-group" style={{
                  display: 'flex',
                  alignItems: 'center',
                  backgroundColor: '#ffffff',
                  borderRadius: '8px',
                  padding: '5px 15px',
                  border: '1px solid #e0e0e0',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                }}>
                  <input
                    placeholder="Type your message..."
                    value={messageInput}
                    onKeyDown={(e) => e.key === 'Enter' && sendMessages()}
                    onChange={(e) => setMessageInput(e.target.value)}
                    className="form-control border-0"
                    style={{
                      backgroundColor: 'transparent',
                      border: 'none',
                      boxShadow: 'none',
                      color: '#495057',
                      flex: '1',
                      padding: '8px 12px'
                    }}
                  />
                  <div className="input-group-append" style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    marginLeft: '10px'
                  }}>
                    <FontAwesomeIcon
                      icon={faFileUpload}
                      onClick={() => fileInputRef.current?.click()}
                      style={{
                        cursor: 'pointer',
                        color: '#6563ff',
                        fontSize: '16px',
                        transition: 'color 0.2s'
                      }}
                      className="attachment-icon"
                    />
                    <img
                      src={sendButtonImg}
                      onClick={sendMessages}
                      alt="Send"
                      style={{
                        cursor: 'pointer',
                        width: '20px',
                        height: '20px',
                        transition: 'opacity 0.2s'
                      }}
                      className="send-icon"
                    />
                  </div>
                </div>
                {selectedFile && (
                  <div className="selected-file mt-2" style={{
                    backgroundColor: '#f8f9fa',
                    padding: '5px 12px',
                    borderRadius: '15px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    fontSize: '13px',
                    border: '1px solid #e0e0e0'
                  }}>
                    <span style={{ color: '#495057' }}>
                      📎 {selectedFile.name}
                    </span>
                    <button
                      onClick={() => setSelectedFile(null)}
                      style={{
                        background: 'none',
                        border: 'none',
                        color: '#dc3545',
                        cursor: 'pointer',
                        padding: '0 5px'
                      }}
                    >
                      ×
                    </button>
                  </div>
                )}
                <input
                  type="file"
                  onChange={(e) => handleFileChange(e)}
                  ref={fileInputRef}
                  style={{ display: 'none' }}
                  accept="image/*, .pdf, .doc, .docx"
                />
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Minimized Chat Button */}
     

      {/* Risk Modal */}
      {showRiskBox && (
        <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header" style={{ flexDirection: 'column', gap: '8px' }}>
                <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <h5 className="modal-title">Raise a risk</h5>
                  <button
                    type="button"
                    className="close"
                    onClick={closeRiskModal}
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                  {questionId && questions.find(q => q.id === questionId)?.response?.isAutoFilled && (
                    <div style={{
                      backgroundColor: '#e6f7ff',
                      color: '#1890ff',
                      padding: '2px 8px',
                      borderRadius: '4px',
                      fontSize: '12px',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '4px',
                      border: '1px solid #91d5ff'
                    }}>
                      <FontAwesomeIcon icon={faSync} style={{ fontSize: '10px' }} />
                      Previously reviewed
                    </div>
                  )}
                  {questionId && questions.find(q => q.id === questionId)?.followupChatStats?.totalMessages > 0 && (
                    <div style={{
                      backgroundColor: '#f6ffed',
                      color: '#52c41a',
                      padding: '2px 8px',
                      borderRadius: '4px',
                      fontSize: '12px',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '4px',
                      border: '1px solid #b7eb8f'
                    }}>
                      <FontAwesomeIcon icon={faComment} style={{ fontSize: '10px' }} />
                      {questions.find(q => q.id === questionId)?.followupChatStats?.totalMessages} Messages
                    </div>
                  )}
                  {questionId && questions.find(q => q.id === questionId)?.riskAnalysis?.hasRisk && !questions.find(q => q.id === questionId)?.riskAnalysis?.isComplete && (
                    <div style={{
                      backgroundColor: '#fff1f0',
                      color: '#ff4d4f',
                      padding: '2px 8px',
                      borderRadius: '4px',
                      fontSize: '12px',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '4px',
                      border: '1px solid #ffccc7'
                    }}>
                      <FontAwesomeIcon icon={faRobot} style={{ fontSize: '10px' }} />
                      AI Flagged
                    </div>
                  )}
                </div>
              </div>
              <div className="modal-body">
                <div className="card mb-2">
                  <div className="row clearfix">
                    <div className="form-group col-lg-12 col-md-12">
                      <label>Risk Title</label>
                      <input
                        type="text"
                        className="form-control"
                        value={riskTitle}
                        onChange={(e) => setRiskTitle(e.target.value)}
                        placeholder="Enter risk title"
                      />
                    </div>
                    <div className="form-group col-md-12">
                      <label>Risk Type</label>
                      <select
                        className="custom-select custom-select-sm form-control form-control-sm"
                        value={riskLevel}
                        onChange={(e) => setRiskLevel(e.target.value)}
                      >
                        <option value="low">Low</option>
                        <option value="medium">Medium</option>
                        <option value="high">High</option>
                        <option value="critical">Critical</option>
                      </select>
                    </div>
                    <div className="form-group col-md-12">
                      <label>Comment</label>
                      <textarea
                        rows="3"
                        placeholder="Enter risk comment"
                        className="form-control"
                        value={riskNote}
                        onChange={(e) => setRiskNote(e.target.value)}
                      />
                    </div>
                    <div className="form-group col-md-12">
                      <label>Recommendation</label>
                      <textarea
                        rows="3"
                        placeholder="Enter risk recommendation"
                        className="form-control"
                        value={riskRecommendation}
                        onChange={(e) => setRiskRecommendation(e.target.value)}
                      />
                    </div>
                    <div className="col-md-12" style={{ display: 'block', width: '100%', textAlign: 'end' }}>
                      <button className="btn btn-primary mr-2" onClick={saveRisk}>
                        Raise Risk
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Add Confirmation Modals */}
      {showApproveConfirm && (
        <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Complete Assessment</h5>
                <button
                  type="button"
                  className="close"
                  onClick={() => setShowApproveConfirm(false)}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to complete this assessment? Please ensure you have raised all necessary risks before proceeding.</p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowApproveConfirm(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={confirmApprove}
                >
                  Approve
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showRejectConfirm && (
        <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Confirm Rejection</h5>
                <button
                  type="button"
                  className="close"
                  onClick={() => setShowRejectConfirm(false)}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to reject this assessment?</p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowRejectConfirm(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={confirmReject}
                >
                  Reject
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showIncompleteModal && (
        <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Mark as Incomplete</h5>
                <button
                  type="button"
                  className="close"
                  onClick={() => {
                    setShowIncompleteModal(false);
                    setIncompleteReason("");
                  }}
                  disabled={isMarkingIncomplete}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <p style={{ marginBottom: '15px' }}>Please provide a reason for marking this assessment as incomplete:</p>
                <div className="form-group">
                  <textarea
                    className="form-control"
                    rows="4"
                    placeholder="Enter reason for marking as incomplete..."
                    value={incompleteReason}
                    onChange={(e) => setIncompleteReason(e.target.value)}
                    disabled={isMarkingIncomplete}
                    style={{ resize: 'vertical' }}
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => {
                    setShowIncompleteModal(false);
                    setIncompleteReason("");
                  }}
                  disabled={isMarkingIncomplete}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-warning"
                  onClick={handleMarkIncomplete}
                  disabled={isMarkingIncomplete || !incompleteReason.trim()}
                >
                  {isMarkingIncomplete ? 'Marking...' : 'Mark as Incomplete'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RiskReview;